export default {
  methods: {
    ogpSet(pageName, img) {
      const title = `${pageName} - NerzExpress`
      const description = "NerzExpress is a service that connects you to fellow otaku in Japan. You will be able to engage with these otaku in various ways such as purchasing owned items directly from them or negotiating terms with them to purchase items for you when they attend various events!"
      document.title = title
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[property='og:url']").setAttribute('content', location.href)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)
      document.querySelector("meta[property='og:image']").setAttribute('content', img)
      document.querySelector("meta[property='og:site_name']").setAttribute('content', title)
      document.querySelector("title").innerHTML = this.escapeHtml(title)
    },

    escapeHtml(str) {
      str = str.replace(/&/g, '&amp;')
      str = str.replace(/</g, '&lt;')
      str = str.replace(/>/g, '&gt;')
      str = str.replace(/"/g, '&quot;')
      str = str.replace(/'/g, '&#39;')
      return str
    }
  }
}
